import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import useApiKey from '@hooks/useApiKey'
import type { ApiKeyModel } from '@models/types'

interface APIKeyListItemProps {
  apiKey: ApiKeyModel,
  disabled?: boolean,
  showUserName?: boolean,
  userSearchRequestOptions?: {
    agency_id?: number,
  },
}

const ApiKeyListItem = (props: APIKeyListItemProps) => {
  const {
    apiKey, disabled, showUserName, userSearchRequestOptions,
  } = props

  const {
    apiKey: {
      enabled, id, title, token,
    },
    callbacks: {
      createOrEditApiKey,
      deleteApiKey: deleteFn,
    },
    // @ts-expect-error TS2339
    user: { full_name, username },
  } = useApiKey(apiKey)

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: { entityName: 'API Key' },
  }

  return (
    <DashboardModuleListItem
      isChecked={enabled}
      secondaryText={username}
      showCheckbox
      title={showUserName ? full_name || 'Deleted User' : title || `API Key #${id}`}
    >
      {showUserName && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.TertiaryText>
          {title}
          <Text fontSize="xsmall" color="bodyFontLightColor">{token}</Text>
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      )}

      {!disabled && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            marginRight="medium"
            onClick={() => createOrEditApiKey({ userSearchRequestOptions })}
            type="edit"
          />

          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            onClick={() => confirmDelete(confirmDeletePayload)}
            type="delete"
          />
          {/*
           // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      )}
    </DashboardModuleListItem>
  )
}

export default ApiKeyListItem
